import React from "react";
import { MultiPickerListProps } from "../props";
import MultiPickerListWithSelectedItems from "../MultiPickerListWithSelectedItems";
import { ClientListItem } from "./ClientList";

const perPage = 20;

const MultiClientList = (props: MultiPickerListProps<server.dto.ClientSmall>) => {
  const [instruction, setInstruction] = React.useState<server.dto.ListClientInstruction>({
    keyword: "",
    page: 1,
    perPage: perPage,
  });

  return <MultiPickerListWithSelectedItems
    instruction={instruction}
    onInstructionChange={setInstruction}
    queryKey="listClient"
    api={window.CoreApi.Client.PaginatedSmall}

    getError={() => undefined}
    excludeKeys={props.excludeKeys}

    onChange={props.onChange}
    renderListItem={ClientListItem}
    getId={client => client.clientId}
    getLabel={client => <div>{client.name}</div>}
    value={props.value}
  />
};

export default MultiClientList;